import React from "react";

const Why = () => {
  return (
    <div data-aos="zoom-in" data-aos-duration="1000" className="w-11/12 mx-auto bg-why-bg bg-cover text-center">
      <div className="md:w-5/12 mx-auto md:py-36 pt-48 pb-20 px-10">
        <h1 className="text-3xl md:text-5xl font-bold pb-10">
          Why Apple is the best place to buy iPhone.
        </h1>
        <p className="text-xl">
          You can choose a payment option that works for you, pay less with a
          trade‑in, connect your new iPhone to your carrier, and get set up
          quickly. You can also chat with a Specialist anytime.
        </p>
      </div>
    </div>
  );
};

export default Why;
